/**
 * SSO API helpers for the Strategizer ↔ SynergenHR integration.
 */

/** POST /sso/login — validate a SynergenHR SSO token, get back a Strategizer JWT */
export async function SsoLoginApi(token) {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}v1/sso/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    });
    return await res.json();
  } catch (err) {
    console.error("SsoLoginApi error:", err);
    return { success: false, message: err.message };
  }
}

/** POST /sso/link — link the logged-in Strategizer user to SynergenHR */
export async function SsoLinkApi(linkToken) {
  const authToken = localStorage.getItem("authToken");
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}v1/sso/link`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({ linkToken }),
    });
    return await res.json();
  } catch (err) {
    console.error("SsoLinkApi error:", err);
    return { success: false, message: err.message };
  }
}

/** GET /sso/status — check if the logged-in user has a linked SynergenHR account */
export async function SsoStatusApi() {
  const authToken = localStorage.getItem("authToken");
  if (!authToken) return { linked: false };
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}v1/sso/status`, {
      headers: { Authorization: `Bearer ${authToken}` },
    });
    return await res.json();
  } catch (err) {
    return { linked: false };
  }
}

/** POST /sso/link-token — generate a link token from Strategizer's side */
export async function SsoGenerateLinkTokenApi() {
  const authToken = localStorage.getItem("authToken");
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}v1/sso/link-token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    });
    return await res.json();
  } catch (err) {
    return { success: false };
  }
}

/** DELETE /sso/unlink — remove the link */
export async function SsoUnlinkApi() {
  const authToken = localStorage.getItem("authToken");
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}v1/sso/unlink`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${authToken}` },
    });
    return await res.json();
  } catch (err) {
    return { success: false };
  }
}
